import { ITakeAway } from '../Types/TakeAways';

export const TakeAways:ITakeAway[] = [
	{
		id: 0,
		text: 'Hands on work',
		subText: 'As a lean team, our decisions were made quickly, and a hands on approach was needed to tackle the huge workload required to launch the concept.'
	},
	{
		id: 1,
		text: 'Cross-Channel',
		subText: 'The project gave me the opportunity to design and influence all aspects of the customer journey, ensuring a seamless cross-channel experience.'
	},
	{
		id: 2,
		text: 'Never Stop Learning',
		subText: 'There were many firsts for me in this project. Being curious, willing to learn, and trusting the process helped me to tackle those challenges and rapidly develop new skills.'
	},
];